import React from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../components/shared/table/pagination/Pagination';
import { nextModelsPageAction, prevModelsPageAction, setModelsPageSizeAction } from '../../redux/actions/modelsActions';

const ModelsPagination = () => {
  const pageable = useSelector((state) => state.models?.pageable);
  return (
    <Pagination
      pageable={pageable}
      onNextPageClickAction={nextModelsPageAction}
      onPrevPageClickAction={prevModelsPageAction}
      onPageSizeChangeAction={setModelsPageSizeAction}
    />
  );
};

export default ModelsPagination;
